/**
 * AdminFeatureBadge — small lock-icon badge that marks a control or
 * section as admin-only.
 *
 * Sprint 16 (#275). Used inside regular-user widgets that surface admin
 * extras so non-admins can see *that* the affordance exists but learn it
 * isn't theirs to use, and admins get a visual confirmation that they're
 * looking at an elevated surface.
 *
 * Props:
 *   tooltip   — context-specific help text (defaults to "Admin only").
 *   inline    — render as an inline span next to a label (default true).
 *
 * The badge does NOT enforce the gate — the backend route or payload
 * shape is the source of truth. This is purely a UI hint.
 */
import './AdminFeatureBadge.css';

export default function AdminFeatureBadge(props) {
  const tip = () => props.tooltip || 'Admin only';
  const cls = () => `v2-admin-badge${props.inline === false ? ' v2-admin-badge--block' : ''}`;
  return (
    <span class={cls()} title={tip()} aria-label={tip()}>
      <span class="v2-admin-badge__icon" aria-hidden="true">🔒</span>
      <span class="v2-admin-badge__label">admin</span>
    </span>
  );
}
